import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative flex-shrink-0 mr-4 ml-2" }
const _hoisted_2 = { class: "w-5 h-5 absolute bottom-0 right-0 rounded-full flex items-center justify-center" }
const _hoisted_3 = { class: "w-40 max-w-44 mr-5" }
const _hoisted_4 = { class: "font-semibold text-left text-wrap text-base mt-1" }
const _hoisted_5 = { class: "flex flex-row flex-nowrap items-center gap-1 w-full" }
const _hoisted_6 = { class: "font-normal text-left text-xs truncate mt-1" }
const _hoisted_7 = { class: "flex flex-row items-center gap-1" }
const _hoisted_8 = { class: "flex grow justify-center items-center" }
const _hoisted_9 = {
  key: 0,
  class: "bg-blue-700 font-mono text-white px-3 py-1 rounded-full text-sm leading-6 font-semibold"
}

import ProviderIcon from '@/components/ProviderIcon.vue';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { CustomerSession, PartnerProviderType } from '@/http/customerSession';
import { ANSWER_CALL, GET_WHO_AM_I, RETRIEVE_SESSION } from '@/store';
import { computed, } from 'vue';
import type { PropType } from 'vue';
import { useStore } from 'vuex';
import Button from '@/components/ui/button/Button.vue';
import { useRoute, useRouter } from 'vue-router';
import { PartnerProvider } from '@/http/partnerProvider';
import { Bot, Check, Image, NotebookPen } from 'lucide-vue-next';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConverzaSessionResume',
  props: {
    session: {
        type: Object as PropType<CustomerSession>,
        required: true
    },
},
  emits: ['TOGGLE_TO_ANSWER_CHAT'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { state, getters, dispatch } = useStore();
const router = useRouter();
const route = useRoute();
const providersAmmount = computed(() => {
    const providersQuantity: Record<PartnerProviderType, number> = {
        'WHATSAPP': 0,
        'INSTAGRAM': 0
    };

    for (let provider of Object.values(state.partnerProviders) as Array<PartnerProvider>) {
        if (provider.partnerProviderType != undefined) {
            providersQuantity[provider.partnerProviderType as PartnerProviderType] += 1;
        }
    }

    return providersQuantity;
});

const dateIsBefore = (firstDate: Date, secondDate: Date) => {
    return firstDate < secondDate;
};

const howManyBeforeLastSupportMessage = computed<number>(() => {
    let count = 0;
    for (let i = props.session.conversation.length - 1; i >= 0; i--) {
        const messageDate = props.session.conversation[i].dateTime;
        const lastRead = props.session.lastRead;
        if (lastRead === undefined || dateIsBefore(messageDate, lastRead)) {
            break;
        }
        count += props.session.conversation[i].sender === 'CUSTOMER' ? 1 : 0;
    }
    return count;
});

const selectedSessionId = computed<string | undefined>(() => {
    const pathSegments = route.path.split('/');
    return pathSegments[pathSegments.length - 1];
});

const clickOnCard = async () => {
    if (props.session.whoIsChatting === getters[GET_WHO_AM_I]) {
        router.push({ path: `/dashboard/atendimento/${props.session.id}` });
        return;
    }

    if (props.session.whoIsChatting === null) {
        await dispatch(ANSWER_CALL, props.session.id);
        await dispatch(RETRIEVE_SESSION, props.session.id);
        router.push({ path: `/dashboard/atendimento/${props.session.id}` });
        return;
    }
};

const isSelected = computed(() => props.session.id === selectedSessionId.value);

const orders = computed(() => state.partnerProvidersOrder);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'hover:bg-gray-100 flex items-center py-4 border-b-2 border-gray-200 pl-1',
            { 'bg-gray-200': isSelected.value }
        ]),
    onClick: _cache[1] || (_cache[1] = () => _unref(router).push({ path: `/dashboard/atendimento/${props.session.id}` }))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Avatar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AvatarImage), {
            src: "https://github.com/radix-vue.png",
            alt: "@radix-vue"
          }),
          _createVNode(_unref(AvatarFallback), null, {
            default: _withCtx(() => [
              _createTextVNode("CN")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Avatar), { class: "w-5 h-5" }, {
          default: _withCtx(() => [
            _createVNode(ProviderIcon, {
              provider: props.session.providerType,
              providerOrder: providersAmmount.value[props.session.providerType] > 1
                            ? String(orders.value[props.session.partnerProviderId])
                            : undefined
            }, null, 8, ["provider", "providerOrder"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.session.customer.partnerAttributes?.name ?? __props.session.customer.key), 1),
      _createElementVNode("div", _hoisted_5, [
        (props.session.conversation.at(-1)?.sender == 'SUPPORT' && props.session.conversation.at(-1)?.target === 'CHAT')
          ? (_openBlock(), _createBlock(_unref(Check), {
              key: 0,
              class: "h-4 w-4 min-w-3 mt-1 opacity-45"
            }))
          : _createCommentVNode("", true),
        (props.session.conversation.at(-1)?.target === 'INTERNAL')
          ? (_openBlock(), _createBlock(_unref(NotebookPen), {
              key: 1,
              class: "h-4 w-4 min-w-3 mt-1 opacity-45"
            }))
          : _createCommentVNode("", true),
        (props.session.conversation.at(-1)?.sender == 'BOT')
          ? (_openBlock(), _createBlock(_unref(Bot), {
              key: 2,
              class: "h-4 w-4 min-w-3 mt-1 opacity-45"
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("p", { class: "font-normal text-left text-xs truncate mt-1" }, _toDisplayString(props.session.conversation.at(-1)?.message?.text ??
                        props.session.conversation.at(-1)?.workflowTask?.content ?? ''), 513), [
          [_vShow, props.session.conversation.at(-1)?.messageType !== 'image']
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_unref(Image), {
              size: 16,
              "stroke-width": 1.25
            }),
            _createTextVNode(" Imagem ")
          ])
        ], 512), [
          [_vShow, props.session.conversation.at(-1)?.messageType === 'image']
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (props.session.whoIsChatting !== null && howManyBeforeLastSupportMessage.value > 0 && !isSelected.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(howManyBeforeLastSupportMessage.value), 1))
        : (props.session.whoIsChatting === null)
          ? (_openBlock(), _createBlock(Button, {
              key: 1,
              variant: "default",
              class: "bg-blue-700 text-white px-3 py-2 rounded-full text-sm leading-6 font-semibold w-[76px] h-8",
              onClick: _cache[0] || (_cache[0] = () => {
                    clickOnCard();
                    emit('TOGGLE_TO_ANSWER_CHAT');
                })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Atender ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})